var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.77 15.6031H5.77002C3.07002 15.6031 1.27002 13.8031 1.27002 11.1031V5.70312C1.27002 3.00312 3.07002 1.20312 5.77002 1.20312H14.77C17.47 1.20312 19.27 3.00312 19.27 5.70312V11.1031C19.27 13.8031 17.47 15.6031 14.77 15.6031Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72986 6.15271L11.9799 7.50275C12.7899 8.04275 12.7899 8.85275 11.9799 9.39275L9.72986 10.7427C8.82986 11.2827 8.10986 10.8327 8.10986 9.84275V7.14275C8.10986 5.97271 8.82986 5.61271 9.72986 6.15271Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFooterYoutube);
export default __webpack_public_path__ + "static/media/ic_footer_youtube.953282646b2215171baf8e52a7804ce7.svg";
export { ForwardRef as ReactComponent };